export default {
  STATUS_DRAFT: "Brouillon",
  STATUS_SUBMITTED: "Soumise",
  STATUS_ACCEPTED: "Acceptée",
  STATUS_REJECTED: "Rejetée",
  STATUS_CANCELED: "Annulée",
  DELETE_ESTABLISHMENT_INTERNAL_INVOICE: "Supprimer la facture interne d'établissement",
  ADD_ITEMS_FIRST: "Ajoutez au moins un article de facture interne avant de soumettre.",
  ACCEPT: "Accepter",
  REJECT: "Rejeter",
  SUBMITTED_BY: "Soumis par",
  SUBMITTED_AT: "Soumis le",
  ACCEPTED_BY: "Accepté par",
  ACCEPTED_AT: "Accepté le",
  DISCOUNT: "Rabais",
  INTERNAL_INVOICE_DATE: "Date de la facture interne",
  INTERNAL_INVOICE_DATE_HELP:
    "La facture interne est datée sur la journée commandée qu'elle règle : c'est cette date qui détermine la semaine du rapport hebdomadaire, quel que soit le jour de l'acceptation. Elle n'est pas modifiable.",
};
